/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesAppointment {
	AVERAGE_TIME = "res://senior.com.br/rh/ponto/analytics/manager/time/average",
	COMPENSATORY_TIME_HOURS_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/timeHoursDiscount",
	COMPENSATORY_TIME_HOURS_PAY = "res://senior.com.br/rh/ponto/analytics/manager/compTime/timeHoursPay",
	COMPENSATORY_TIME_HOURS_PAY_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/closing",
	COMPENSATORY_TIME_PROJECTION_HOURS_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursDiscount",
	COMPENSATORY_TIME_PROJECTION_HOURS_PAY = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursPay",
	COMPENSATORY_TIME_PROJECTION_HOURS_PAY_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursPayAndDiscount",
	COMPENSATORY_TIME_BALANCE_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/my/compTime/balance",
	COMPENSATORY_TIME_BALANCE_MANAGER = "res://senior.com.br/rh/ponto/analytics/manager/compTime/balance",
	TIME_ADJUSTMENT_CURRENT_STATE = "res://senior.com.br/rh/ponto/analytics/manager/timeAdjustment/currentState",
	TIME_ADJUSTMENT_PENDENCY = "res://senior.com.br/rh/ponto/analytics/manager/timeAdjustment/pendency",
	TIME_ATTENDANCE_MONITOR = "res://senior.com.br/rh/ponto/analytics/manager/presence/monitor",
	TOTAL_TIME = "res://senior.com.br/rh/ponto/analytics/manager/time/total",
	TIME_ADJUSTMENT_PENDENCY_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/my/timeAdjustment/pendency",
	TOTAL_TIME_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/my/time/total",
	COMPENSATORY_TIME_SUMMARY = "res://senior.com.br/rh/ponto/analytics/my/compTime/summary",
	TODAYS_JOURNEY_DRILL = "res://senior.com.br/rh/ponto/gestaoponto/sempreemponto",
	TODAYS_JOURNEY = "res://senior.com.br/rh/ponto/analytics/my/todaysJourney",
	COMPENSATORY_TIME_PROJECTION = "res://senior.com.br/rh/ponto/analytics/my/compTime/projection/employee",
	INCIDENTE_JUSTIFICATION_MANAGER = "res://senior.com.br/rh/ponto/analytics/manager/incident/incidentJustification",
	INCIDENTE_JUSTIFICATION_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/employee/incident/incidentJustification",
	INCIDENT_MORE_OCCURRENCES = "res://senior.com.br/rh/ponto/analytics/manager/incident/moreOccurrences",
	INCIDENT_COMPETENCE_SUMMARY = "res://senior.com.br/rh/ponto/analytics/manager/incident/total",
	HOURS_IN_VALUE = "res://senior.com.br/rh/ponto/analytics/manager/bancoHoras/horaEmValor"
}

/**
 * Cards da página Manager, aba Appointment
 */
export enum PermissionResourcesAppointmentManager {
	AVERAGE_TIME = "res://senior.com.br/rh/ponto/analytics/manager/time/average",
	COMPENSATORY_TIME_HOURS_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/timeHoursDiscount",
	COMPENSATORY_TIME_HOURS_PAY = "res://senior.com.br/rh/ponto/analytics/manager/compTime/timeHoursPay",
	COMPENSATORY_TIME_HOURS_PAY_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/closing",
	COMPENSATORY_TIME_PROJECTION_HOURS_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursDiscount",
	COMPENSATORY_TIME_PROJECTION_HOURS_PAY = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursPay",
	TIME_ADJUSTMENT_CURRENT_STATE = "res://senior.com.br/rh/ponto/analytics/manager/timeAdjustment/currentState",
	TIME_ADJUSTMENT_PENDENCY = "res://senior.com.br/rh/ponto/analytics/manager/timeAdjustment/pendency",
	TIME_ATTENDANCE_MONITOR = "res://senior.com.br/rh/ponto/analytics/manager/presence/monitor",
	TOTAL_TIME = "res://senior.com.br/rh/ponto/analytics/manager/time/total",
	COMPENSATORY_TIME_PROJECTION_HOURS_PAY_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursPayAndDiscount",
	COMPENSATORY_TIME_BALANCE_MANAGER = "res://senior.com.br/rh/ponto/analytics/manager/compTime/balance",
	ABSENTEEISM = "res://senior.com.br/analytics/hcm/clocking/manager/absenteeismSummary",
	OVERTIME_HOURS_IN_CALCULATION_PERIOD = "res://senior.com.br/analytics/hcm/time/overtimeCalculationPeriod",
	INCIDENTE_JUSTIFICATION_MANAGER = "res://senior.com.br/rh/ponto/analytics/manager/incident/incidentJustification",
	INCIDENT_MORE_OCCURRENCES = "res://senior.com.br/rh/ponto/analytics/manager/incident/moreOccurrences",
	INCIDENT_COMPETENCE_SUMMARY = "res://senior.com.br/rh/ponto/analytics/manager/incident/total",
	HOURS_IN_VALUE = "res://senior.com.br/rh/ponto/analytics/manager/bancoHoras/horaEmValor"
}

/**
 * Cards da página My, aba Appointment
 */
export enum PermissionResourcesAppointmentMy {

	TIME_ADJUSTMENT_PENDENCY_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/my/timeAdjustment/pendency",
	TOTAL_TIME_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/my/time/total",
	COMPENSATORY_TIME_SUMMARY = "res://senior.com.br/rh/ponto/analytics/my/compTime/summary",
	TODAYS_JOURNEY = "res://senior.com.br/rh/ponto/analytics/my/todaysJourney",
	COMPENSATORY_TIME_PROJECTION = "res://senior.com.br/rh/ponto/analytics/my/compTime/projection/employee",
	COMPENSATORY_TIME_BALANCE_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/my/compTime/balance",
	INCIDENTE_JUSTIFICATION_EMPLOYEE = "res://senior.com.br/rh/ponto/analytics/employee/incident/incidentJustification"

}

/**
 * Cards da página Led, aba Appointment
 */
export enum PermissionResourcesAppointmentLed {
	AVERAGE_TIME = "res://senior.com.br/rh/ponto/analytics/manager/time/average",
	COMPENSATORY_TIME_HOURS_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/timeHoursDiscount",
	COMPENSATORY_TIME_PROJECTION_HOURS_DISCOUNT = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursDiscount",
	COMPENSATORY_TIME_PROJECTION_HOURS_PAY = "res://senior.com.br/rh/ponto/analytics/manager/compTime/projectionHoursPay",
	TIME_ADJUSTMENT_CURRENT_STATE = "res://senior.com.br/rh/ponto/analytics/manager/timeAdjustment/currentState",
	TIME_ADJUSTMENT_PENDENCY = "res://senior.com.br/rh/ponto/analytics/manager/timeAdjustment/pendency",
	TOTAL_TIME = "res://senior.com.br/rh/ponto/analytics/manager/time/total",
	COMPENSATORY_TIME_BALANCE_MANAGER = "res://senior.com.br/rh/ponto/analytics/manager/compTime/balance",
	INCIDENTE_JUSTIFICATION_MANAGER = "res://senior.com.br/rh/ponto/analytics/manager/incident/incidentJustification",
	INCIDENT_MORE_OCCURRENCES = "res://senior.com.br/rh/ponto/analytics/manager/incident/moreOccurrences",
	INCIDENT_COMPETENCE_SUMMARY = "res://senior.com.br/rh/ponto/analytics/manager/incident/total",
	HOURS_IN_VALUE = "res://senior.com.br/rh/ponto/analytics/manager/bancoHoras/horaEmValor"
}
